import { config } from '@/utils/config';

export const mediaMixin = {
  data() {
    return {
      mediaUrl: config.mediaURL && config.mediaURL.endsWith('/') ? config.mediaURL : config.mediaURL + '/'
    };
  },
  methods: {
    // @vuese
    // URL do pobrania pliku
    downloadUrl(id) {
      return this.mediaUrl + id;
    }
  }
};
